module.exports = __webpack_public_path__ + "static/img/train-count.17e34d80.png";